import PermissionTypeRepository from "@common/domain/data/PermissionTypeRepository";
import PermissionType from "@common/domain/entities/PermissionType";
import User from "@common/domain/entities/User";

export default class APIPermissionTypeRepository implements PermissionTypeRepository{
    getPermissionTypes(user: User): Promise<PermissionType[]> {
        throw new Error("Method not implemented.");
    }
    
}